import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HomeIcon from '@material-ui/icons/Home';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import ScholarshipsIcon from '../../../assets/img/planner-scholarships-icon.svg';
import ScholarshipApp from '../../Scholarship/ScholarshipApp';
import { useReactToPrint } from 'react-to-print';
import { isStudent, isAlumni } from '../../../util/miscUtil';

const SCHOLARSHIP_APP_DESC = (
  <>
    Please enter the information below and complete a 2000-word essay to apply to the <em>Workforce Development Scholarships</em> &amp;{' '}
    <em>Post-graduation Supports</em>. Attach copies of ALL information requested.
  </>
);

const Scholarship = ({
  senior,
  alumni,
  roles,
  handleHelp,
  store,
  auth,
  handleAfterSaveReturn,
  setPage,
  handleReturnToSeniorList,
  classes,
  handleGotoAdminHomepage,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const version = store?.scholarshipApp?.version || 0;
  return (
    <React.Fragment>
      {!isStudent(roles) && !isAlumni(roles) && (
        <Grid container direction="row" className={classes.unprintedContent}>
          <Grid item xs={12}>
            <div className={classes.breadcrumbs}>
              <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={(e) => handleGotoAdminHomepage()}>
                  <HomeIcon style={{ fontSize: '1.30rem' }} />
                  <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                </span>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
                  {alumni ? 'Alumni' : 'High School Seniors'}
                </span>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                  {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                  {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                </span>
                <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('scholarshipapps')}>
                  Scholarship Applications
                </span>
                <Typography color="textPrimary" className={classes.breadCrumbText}>
                  Application
                </Typography>
              </Breadcrumbs>
            </div>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2} direction="row" className={classes.menu} ref={componentRef}>
        <Grid item xs={12} align="left" className={classes.unprintedContent}>
          <Card className={classes.pageHeader}>
            <CardBody className={classes.headerCard}>
              <Grid container direction="row">
                <Grid item xs={10} align="left">
                  <section className={classes.pageTitle}>
                    <img src={ScholarshipsIcon} alt="Scholarship Icon" className={classes.pageIcon} />
                    <span className={classes.pagecardHeader}>Scholarship Application</span>
                  </section>
                  {version !== 2 && <aside className={classes.headerDesc}>{SCHOLARSHIP_APP_DESC}</aside>}
                </Grid>
                <Grid item xs={2} align="right">
                  <Tooltip title="Click to return to the planner home page." placement="bottom">
                    <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                      <HomeIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to open the printer dialog." placement="bottom">
                    <IconButton color="inherit" aria-label="print scholarship application" onClick={handlePrint}>
                      <PrintIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to view printer tips & tricks." placement="bottom">
                    <IconButton color="inherit" aria-label="printer tips and tricks" onClick={handleHelp}>
                      <HelpIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} align="left" className={classes.printedContent}>
          <section className={classes.pageTitle}>
            <span className={classes.printHeaderText}>Scholarship Application</span>
          </section>
          {version !== 2 && <aside className={classes.printHeaderDesc}>{SCHOLARSHIP_APP_DESC}</aside>}
        </Grid>
        <Grid item xs={12}>
          <ScholarshipApp SeniorStore={store} AuthStore={auth} handleSaveReturn={handleAfterSaveReturn} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

Scholarship.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  handleHelp: PropTypes.func,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default Scholarship;
